// extracted by mini-css-extract-plugin
export var gif = "_g2-0";